<template>
  <div class="bg">
    <van-overlay :show="showExchange" @click="clickBg">
      <div class="ex_con colof" @click.stop>
        <img src="@/assets/mine/bg_exchange@2x.png" alt="" class="bg_img" />
        <div class="bg_con">
          <div class="font18 font_weight500 con_title line_height_25">
            兑换商品
          </div>
          <div class="font14 font_weight400 con_det line_height_20">
            确认兑换 {{ chooseItem.voucherName }}，兑换需消耗 1 张礼品卡
          </div>
          <div class="con_middle">
            <img :src="chooseItem.leftImg" alt="" class="middle_left" />
            <img
              src="@/assets/mine/line_go@2x.png"
              alt=""
              class="middle_center"
            />
            <div class="middle_right">
              <img src="@/assets/mine/milk_bg@2x.png" alt="" class="right_bg" />
              <div class="bg_top">
                <img :src="chooseItem.rightImg" alt="" class="bg_milk" />
              </div>
              <div class="font12 font_weight400 line_height_17 pro_name">
                实物商品
              </div>
            </div>
          </div>
          <div class="bottom_btn font16 font_weight500" @click="useCard">
            兑换并使用
          </div>
          <img
            src="@/assets/common/icon_close@2x.png"
            alt=""
            class="close_img"
            @click="clickBg"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  props: {
    showExchange: {
      type: Boolean,
      default: false
    },
    chooseItem: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    clickBg() {
      this.$emit("clickBg");
    },
    useCard() {
      this.$emit("useCard", this.chooseItem.id);
    }
  }
};
</script>
<style lang="less" scoped>
.bg {
  .ex_con {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .bg_img {
      width: 320px;
    }
    .bg_con {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      .con_title {
        margin-top: 22px;
        color: #3d322b;
      }
      .con_det {
        margin-top: 10px;
        color: rgba(61, 50, 43, 0.8);
      }
    }
    .con_middle {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 40px;
      .middle_left {
        width: 104px;
        // max-height: 68px;
      }
      .middle_center {
        width: 33px;
        height: 17.7px;
        margin: 0 5px;
      }
      .middle_right {
        width: 120px;
        height: 132px;
        position: relative;
        .right_bg {
          width: 100%;
        }
        .bg_top {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          .bg_milk {
            width: 80px;
            max-height: 80px;
          }
        }
        .pro_name {
          position: absolute;
          bottom: 10px;
          left: 0;
          right: 0;
        }
      }
    }
    .bottom_btn {
      background: linear-gradient(180deg, #706156 0%, #3d322b 100%);
      box-shadow: 0px 2px 4px 0px #b18960;
      border-radius: 23px;
      border: 1px solid #fff;
      line-height: 45px;
      color: #ffe7d6;
      margin: 58px 56px;
    }
  }
  .close_img {
    width: 24px;
  }
}
</style>
